import {Box, Button, Chip, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {CheckIcon, Copy01Icon, ServerIcon} from "@hugeicons/core-free-icons";

const headerCellSx = {
    fontWeight: 700, fontSize: 11, py: 1,
    color: "text.secondary", textTransform: "uppercase",
    letterSpacing: 0.5, bgcolor: "grey.50", whiteSpace: "nowrap",
};

export const KnowledgeTopicsList = ({topics, onOpen, formatDate, statusColor, onCopy, copiedId}) => (
    <TableContainer className="border-shadow" sx={{borderRadius: 2, overflow: "auto"}}>
        <Table size="small" aria-label="Knowledge topics" sx={{tableLayout: "auto"}}>
            <TableHead>
                <TableRow sx={{bgcolor: "grey.50"}}>
                    {["Topic", "Server", "Status", "Documents", "Queries", "Updated", "Tags"].map(label => (
                        <TableCell key={label} sx={headerCellSx}>{label}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody sx={{"& .MuiTableCell-root": {fontSize: 12, color: "text.secondary"}}}>
                {topics.map(topic => {
                    const status = topic.server ? statusColor(topic.server.status) : null;
                    return (
                        <TableRow key={topic.id} hover onClick={() => onOpen(topic)} sx={{cursor: "pointer"}}>
                            <TableCell sx={{minWidth: 180, maxWidth: 320}}>
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <Box sx={{width: 8, height: 8, borderRadius: "50%", bgcolor: topic.color, flexShrink: 0}}/>
                                    <Button onClick={event => {event.stopPropagation(); onOpen(topic);}} sx={{p: 0, minWidth: 0, fontSize: 13, fontWeight: 600, color: "text.primary", textAlign: "left", textTransform: "none", justifyContent: "flex-start", overflowWrap: "anywhere"}}>{topic.name}</Button>
                                </Stack>
                                <Typography fontSize={11} color="text.secondary" noWrap sx={{maxWidth: 280}} title={topic.description}>{topic.description}</Typography>
                            </TableCell>
                            <TableCell sx={{maxWidth: 260}}>
                                {topic.server ? (
                                    <Stack direction="row" alignItems="center" gap={0.5} sx={{minWidth: 0}}>
                                        <HugeiconsIcon icon={ServerIcon} size={14}/>
                                        <Typography fontSize={12} fontFamily="monospace" sx={{minWidth: 0, overflowWrap: "anywhere"}}>
                                            {topic.server.apiBase || topic.server.url || topic.server.endpoint || `http://${topic.server.host}:${topic.server.port}`}
                                        </Typography>
                                        <Tooltip title="Copy server URL">
                                            <IconButton size="small" aria-label={`Copy URL for ${topic.name}`} onClick={event => {event.stopPropagation(); onCopy(topic);}} sx={{p: 0.25, flexShrink: 0}}>
                                                <HugeiconsIcon icon={copiedId === topic.id ? CheckIcon : Copy01Icon} size={14}/>
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                ) : "Not configured"}
                            </TableCell>
                            <TableCell>{topic.server ? <Chip label={topic.server.status} size="small" sx={{bgcolor: status.bg, color: status.color, fontSize: 11, height: 22, fontWeight: 500, borderRadius: 2, border: "none"}}/> : "-"}</TableCell>
                            <TableCell>{topic.documentCount || 0}</TableCell>
                            <TableCell>{topic.queryCount || 0}</TableCell>
                            <TableCell sx={{whiteSpace: "nowrap"}}>{formatDate(topic.updatedAt) || "-"}</TableCell>
                            <TableCell><Stack direction="row" flexWrap="wrap" gap={0.5} sx={{minWidth: 100}}>{topic.tags?.map(tag => <Chip key={tag} label={tag} size="small" sx={{fontSize: 10, height: 20, borderRadius: 1.5, bgcolor: "action.hover", color: "text.secondary", border: "none"}}/>)}</Stack></TableCell>
                        </TableRow>
                    );
                })}
                {topics.length === 0 && <TableRow><TableCell colSpan={7} align="center" sx={{py: 4}}>No topics created yet.</TableCell></TableRow>}
            </TableBody>
        </Table>
    </TableContainer>
);
